export default "__VITE_ASSET__uwD_5Dv5__"